import { defineBlock, InnerBlocks } from "eddev/blocks"
import { MenuProvider } from "../../contexts/MenuContext"
import { Link } from "eddev/routing"

export const meta: BlockMeta = {
  title: "Site Header",
  description: "The header of the site",
  icon: "hammer",
}

export default defineBlock("parts/part-site-header", (props) => {
  return (
    <MenuProvider>
      <InnerBlocks
        allowedBlocks={["header/menu"]}
        template={[["header/menu", {}]]}
        templateLock="all"
        orientation="vertical"
      />
    </MenuProvider>
  )
})
